import { FC } from 'react'
import { FeatureFlag, useFeatureFlag } from 'utils/featureFlags'
import { MUITooltip } from 'components/common/MUITooltip'
import { Stack } from '@mui/material'
import { PropstackIconTile } from './PropstackIcons'
import { UserWorkspaceMembership } from 'models/user'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Propstack membership data of the displayed workspace */
  workspace?: UserWorkspaceMembership
}

/**
 * Small black layers tile shown next to the active workspace name in the top bar when that
 * workspace is Propstack-provisioned (ISSUE-2136). Self-gating: renders nothing unless the
 * feature flag is on and the workspace is Propstack-linked.
 * @example <PropstackWorkspaceMark workspace={getPropstackMembership(displayedWorkspace.id)} />
 */
export const PropstackWorkspaceMark: FC<Props> = ({ workspace }) => {
  const { t } = useTranslation(['workspace_profile'])
  const propstackIntegration = useFeatureFlag(FeatureFlag.PROPSTACK_INTEGRATION)

  if (!propstackIntegration || !workspace?.propstackLinked) return null

  return (
    <Stack marginRight=".8rem">
      <MUITooltip content={t('propstack_banner.popover_title')}>
        <PropstackIconTile size={22} icon="layers" />
      </MUITooltip>
    </Stack>
  )
}
